import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const Icon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
`;

const ShopButton = styled(Link)`
  display: inline-block;
  background-color: #479de6;
  color: #fff;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #3a8ed4;
    text-decoration: none;
    color: #fff;
  }
`;

const EmptyOrdersState = () => {
  return (
    <Container>
      <Icon>📦</Icon>
      <Title>No orders yet</Title>
      <Description>
        When you place an order, it will appear here for easy tracking.
      </Description>
      <ShopButton to="/dashboard">Start Shopping</ShopButton>
    </Container>
  );
};

export default EmptyOrdersState;
